import type { Mission } from '../missions.ts'

export const fws: Mission = {
  id: "fws",
  name: "U.S. Fish and Wildlife Service",
  short: "FWS",
  call: "Wildlife",
  kind: "subagency",
  parent: "doi",
  url: "https://www.fws.gov/",
  established: 1940,
  palette: {
    primary: "#0270bb",
    secondary: "#564535",
    accent: "#faa225",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Fish_and_Wildlife_Service.svg",
  },
  motif: "dove",
  mission: {
    text: "The mission of the U.S. Fish and Wildlife Service is working with others to conserve, protect, and enhance fish, wildlife, plants, and their habitats for the continuing benefit of the American people.",
    url: "https://www.fws.gov/about-us",
  },
  fact: {
    text: "The U.S. Fish and Wildlife Service is the nation's oldest conservation agency, with origins in the U.S. Fish Commission that Congress established in 1871.",
    url: "https://www.fws.gov/about-us",
  },
  seal: {
    file: "public/seals/fws.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Fish_and_Wildlife_Service.svg",
  },
  identifier: {
    about: "https://www.fws.gov/about-us",
    accessibility: "https://www.fws.gov/help/accessibility",
    foia: "https://www.doi.gov/foia",
    noFear: "https://www.doi.gov/pmb/eeo/no-fear-act",
    oig: "https://www.doioig.gov/",
    performance: "https://www.fws.gov/program/budget",
    privacy: "https://www.fws.gov/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/fws-chincoteague.jpg",
        small: "/media/fws-chincoteague-sm.jpg",
        alt: "Flocks of waterfowl rise into an orange sunrise sky above a salt marsh, with more birds resting on the water.",
        title: "Sunrise at Chincoteague National Wildlife Refuge, Virginia",
        creator: "Steve Hillebrand, U.S. Fish and Wildlife Service",
        source: "https://commons.wikimedia.org/wiki/File:Photo_of_the_Week_-_Sunrise_at_Chincoteague_National_Wildlife_Refuge_(VA)_(4349723396).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/fws-arctic-refuge.jpg",
        small: "/media/fws-arctic-refuge-sm.jpg",
        alt: "A braided river channel crosses flat coastal tundra toward snow-capped mountains in soft evening light.",
        title: "Arctic National Wildlife Refuge, Alaska",
        creator: "Danielle Brigida, U.S. Fish and Wildlife Service",
        source: "https://commons.wikimedia.org/wiki/File:Arctic_National_Wildlife_Refuge_(48772000818).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
